<template>
  <div class="row mx-0 px-3 py-4 border-top gap-3">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">郵便番号</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row p-0">
        <div class="col-12 col-md-4 pe-0 mb-3 mb-md-0">
          <Field v-slot="{ field, errors }" v-model="additionalStore.zip_code" name="zip_code">
            <input
              class="input-primary form-control size-14 bg-silver-primary border-0 p-0d8"
              :class="{ 'is-invalid': !!errors.length || !!errorMessageZipcode.length }"
              placeholder=""
              v-bind="field"
              @keypress="isZipCode($event)"
            />
            <ErrorMessage name="zip_code" class="invalid-feedback" />
            <div v-if="!!errorMessageZipcode.length && !errors.length" class="text-danger size-13">
              {{ errorMessageZipcode }}
            </div>
          </Field>
        </div>
        <div class="d-md-block d-flex justify-content-center col-12 col-md-4 m-0 pt-md-1">
          <button
            type="button"
            class="btn btn-outline-secondary py-0d75 d-flex justify-content-center align-items-center size-12 w-12 rounded-5 h-36x"
            @click="searchAddressWithZipcode"
          >
            <img src="@/assets/images/icons/pen.svg" class="w-0d75 h-0d75" />
            <span class="ms-2">住所自動入力</span>
          </button>
        </div>
      </div>
    </div>
    <div class="input-group row pe-0">
      <div class="col-12 col-md-6 pe-0 mb-3">
        <div
          class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
        >
          <label class="size-12" for="">現住所（都道府県　市区町村）</label>
          <span class="tag-thirdly size-10 ms-2">必須</span>
        </div>
        <div class="col-12 pe-0">
          <Field v-slot="{ errors }" v-model="additionalStore.prefecture_id" name="prefecture_id">
            <div
              :class="`bg-grey-05 rounded-2 w-100 h-46x border-1 border cursor-pointer size-14 lh-14 p-12x d-flex align-items-center ${
                !!errors.length ? 'is-invalid' : ''
              }`"
              @click="onOpenCurrentPrefecture"
            >
              <div v-if="additionalStore?.city_name && additionalStore?.prefecture_name">
                {{ additionalStore?.prefecture_name }} {{ additionalStore?.city_name }}
              </div>
              <div v-else class="color-grey-placeholder">選択してください</div>
            </div>
            <div v-if="errors[0]" class="invalid-feedback d-block">{{ errors[0] }}</div>
          </Field>
        </div>
      </div>
      <div class="col-12 col-md-6 pe-0">
        <div
          class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
        >
          <label class="size-12" for="">現住所（町名-番地）</label>
          <span class="tag-thirdly size-10 ms-2">必須</span>
        </div>
        <div class="col-12 pe-0 mb-3">
          <Field v-slot="{ field, errors }" v-model="additionalStore.address" name="address">
            <input
              type="text"
              class="input-primary form-control size-14 bg-silver-primary border-0 p-0d8"
              placeholder="例）恵比寿1-1-1　ハイツ202"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
            />
            <ErrorMessage name="address" class="invalid-feedback" />
          </Field>
        </div>
      </div>
    </div>
  </div>

  <ModalBase
    ref="modalCurrentPrefecture"
    element="modalCurrentPrefectureElement"
    title="エリアを選ぶ"
    @addItems="addPefecture"
  >
    <template #body>
      <div class="d-none d-md-block">
        <div class="pills-primary row align-items-start py-4 px-5 mx-0">
          <div
            id="prefecture-tab"
            class="nav flex-column col nav-pills me-3 px-0"
            role="tablist"
            aria-orientation="vertical"
          >
            <button
              v-for="prefecture in prefectures"
              :id="`pills-prefecture-${prefecture.id}-tab`"
              :key="prefecture.id"
              class="nav-link py-3 px-4"
              :class="{ active: prefecture.id === areaCity }"
              data-bs-toggle="pill"
              :data-bs-target="`#pills-prefecture-${prefecture.id}`"
              type="button"
              role="tab"
              :aria-controls="`pills-prefecture-${prefecture.id}`"
              aria-selected="false"
            >
              {{ prefecture.name }}
            </button>
          </div>
          <div id="prefecture-tabContent" class="tab-content col">
            <div
              v-for="prefecture in prefectures"
              :id="`pills-prefecture-${prefecture.id}`"
              :key="prefecture.id"
              class="tab-pane fade"
              :class="{ 'show active': prefecture.id == areaCity }"
              role="tabpanel"
              :aria-labelledby="`pills-prefecture-${prefecture.id}-tab`"
              tabindex="0"
            >
              <div id="accordion-prefecture" class="accordion accordion-sixth">
                <div
                  v-for="childrenPrefecture in prefecture.children"
                  :key="childrenPrefecture.id"
                  :class="`accordion-item ${
                    prefecture.children &&
                    childrenPrefecture === prefecture.children[prefecture.children.length - 1]
                      ? 'border-bottom'
                      : ''
                  }`"
                >
                  <h4 class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}`"
                      aria-expanded="true"
                      :aria-controls="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}`"
                    >
                      <span
                        class="text-decoration-none size-14 bg-white pe-1 d-flex align-items-center"
                      >
                        <label
                          class="form-check-label size-12 ms-3"
                          :for="`prefecture-item-input-${prefecture.id}-children-${childrenPrefecture.id}`"
                        >
                          {{ childrenPrefecture.name }}
                        </label>
                      </span>
                    </button>
                  </h4>
                  <div
                    :id="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}`"
                    class="accordion-collapse collapse"
                  >
                    <div
                      :id="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}`"
                      class="accordion-body p-0"
                    >
                      <div
                        v-for="city in childrenPrefecture.main_cities"
                        :key="city.id"
                        class="ps-4 pe-3 py-2 border-bottom"
                      >
                        <label
                          class="form-check-label size-12 ms-3 d-flex align-items-center"
                          :for="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-city-${city.id}-input`"
                        >
                          <input
                            :id="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-city-${city.id}-input`"
                            v-model="additionalStore.city_id"
                            type="radio"
                            class="form-check-input checkbox-primary-input w-1d5 h-1d5"
                            :value="city.id"
                            :checked="additionalStore.city_id == city.id"
                            @change="updatePrefectureWithCity(childrenPrefecture, city)"
                          />
                          <span class="ps-3">
                            {{ city.name }}
                          </span>
                        </label>
                      </div>
                      <div
                        v-if="childrenPrefecture.extra_cities.length > 0"
                        id="prefecture-accordion"
                        class="accordion accordion-primary"
                      >
                        <div class="accordion-item rounded-0 border-0">
                          <h4
                            class="accordion-header border-0 text-decoration-none size-14 bg-white d-flex align-items-center"
                          >
                            <label
                              class="accordion-button collapsed form-check-label bg-white size-12 d-flex align-items-center ps-4 py-2 border-0"
                              :for="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-city-extra`"
                              data-bs-toggle="collapse"
                              :data-bs-target="`#prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-extra-cities`"
                              aria-expanded="true"
                              :aria-controls="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-extra-cities`"
                            >
                              <span class="ps-3">それ以外の市町村</span>
                            </label>
                          </h4>
                          <div
                            :id="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-extra-cities`"
                            class="accordion-body p-0 collapse"
                          >
                            <div
                              v-for="(city, index) in childrenPrefecture.extra_cities"
                              :key="city.id"
                              class="ps-4 pe-3 py-2"
                              :class="{
                                'border-top':
                                  index > 0 && childrenPrefecture.extra_cities.length - 1 >= index,
                              }"
                            >
                              <label
                                class="form-check-label size-12 ms-3 d-flex align-items-center ps-0 ps-md-2"
                                :for="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-city-${city.id}`"
                              >
                                <input
                                  :id="`prefecture-item-${prefecture.id}-children-${childrenPrefecture.id}-city-${city.id}`"
                                  v-model="additionalStore.city_id"
                                  type="radio"
                                  class="form-check-input checkbox-primary-input w-1d5 h-1d5"
                                  :value="city.id"
                                  @change="updatePrefectureWithCity(childrenPrefecture, city)"
                                />
                                <span class="ps-3">
                                  {{ city.name }}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="prefecture-accordion" class="accordion accordion-primary d-md-none">
        <div v-for="prefecture in prefectures" :key="prefecture.id" class="accordion-item">
          <h4 class="accordion-header">
            <a
              class="accordion-button collapsed text-decoration-none size-14 bg-white ps-2 pe-3 py-2"
              data-bs-toggle="collapse"
              :data-bs-target="`#prefecture-current-item-${prefecture.id}`"
              aria-expanded="true"
              :aria-controls="`prefecture-current-item-${prefecture.id}`"
            >
              {{ prefecture.name }}
            </a>
          </h4>
          <div
            :id="`prefecture-current-item-${prefecture.id}`"
            class="accordion-collapse collapse collapse-parent"
          >
            <div class="accordion-body px-4 py-0">
              <div class="accordion accordion-primary">
                <div
                  v-for="children in prefecture.children"
                  :key="children.id"
                  class="accordion-item border-top-0 rounded-0 border-0"
                >
                  <h4
                    class="accordion-header px-3 py-2 accordion-button collapsed bg-white"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#prefecture-current-item-${prefecture.id}-children-${children.id}`"
                    aria-expanded="true"
                    :aria-controls="`prefecture-current-item-${prefecture.id}-children-${children.id}`"
                  >
                    <label
                      class="form-check-label size-12 ms-3"
                      :for="`prefecture-item-input-${prefecture.id}-children-${children.id}`"
                    >
                      {{ children.name }}
                    </label>
                  </h4>
                  <div
                    :id="`prefecture-current-item-${prefecture.id}-children-${children.id}`"
                    class="accordion-body p-0 collapse"
                  >
                    <div
                      v-for="city in children.main_cities"
                      :key="city.id"
                      class="ps-4 pe-3 py-2 border-bottom"
                      :class="{ 'border-top': city === children.main_cities[0] }"
                    >
                      <label
                        class="form-check-label size-12 ms-3 d-flex align-items-center"
                        :for="`prefecture-item-${prefecture.id}-children-${children.id}-city-${city.id}`"
                      >
                        <input
                          :id="`prefecture-item-${prefecture.id}-children-${children.id}-city-${city.id}`"
                          v-model="additionalStore.city_id"
                          type="radio"
                          :name="`prefecture-item-${prefecture.id}-children-${children.id}-cities`"
                          class="form-check-input radio-primary-input w-1d5 h-1d5"
                          :value="city.id"
                          :checked="additionalStore.city_id == city.id"
                          @change="updatePrefectureWithCity(children, city)"
                        />
                        <span class="ps-3">
                          {{ city.name }}
                        </span>
                      </label>
                    </div>
                    <div
                      v-if="children.extra_cities.length > 0"
                      id="prefecture-accordion"
                      class="accordion accordion-primary"
                    >
                      <div class="accordion-item rounded-0 border-0">
                        <h4
                          class="accordion-header border-0 text-decoration-none size-14 bg-white d-flex align-items-center px-0 px-md-4"
                        >
                          <label
                            class="accordion-button collapsed form-check-label bg-white size-12 d-flex align-items-center ps-4 py-2 border-0"
                            :for="`prefecture-item-${prefecture.id}-children-${children.id}-city-extra`"
                            data-bs-toggle="collapse"
                            :data-bs-target="`#md-prefecture-item-${prefecture.id}-children-${children.id}-extra-cities`"
                            aria-expanded="true"
                            :aria-controls="`md-prefecture-item-${prefecture.id}-children-${children.id}-extra-cities`"
                          >
                            <span class="ps-3">それ以外の市町村</span>
                          </label>
                        </h4>
                        <div
                          :id="`md-prefecture-item-${prefecture.id}-children-${children.id}-extra-cities`"
                          class="accordion-body p-0 collapse"
                        >
                          <div
                            v-for="(city, index) in children.extra_cities"
                            :key="city.id"
                            class="ps-4 pe-3 py-2"
                            :class="{
                              'border-top': index > 0 && children.extra_cities.length - 1 >= index,
                            }"
                          >
                            <label
                              class="form-check-label size-12 ms-3 d-flex align-items-center"
                              :for="`prefecture-item-${prefecture.id}-children-${children.id}-city-${city.id}`"
                            >
                              <input
                                :id="`prefecture-item-${prefecture.id}-children-${children.id}-city-${city.id}`"
                                v-model="additionalStore.city_id"
                                type="radio"
                                class="form-check-input radio-primary-input w-1d5 h-1d5"
                                :name="`prefecture-item-${prefecture.id}-children-${children.id}-cities`"
                                :value="city.id"
                                :checked="additionalStore.city_id == city.id"
                                @change="updatePrefectureWithCity(children, city)"
                              />
                              <span class="ps-3">
                                {{ city.name }}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, watchEffect } from 'vue';
import { useAdditionalStore } from '@/stores/resume-candidate/Additional.store';
import { ErrorMessage, Field } from 'vee-validate';
import { CountryPrimary } from '@/types/models/country';
import { CityPrimary } from '@/types/models/city';
import { PrefecturePrimary } from '@/types/models/prefecture';
import {
  getCountries,
  getPrefectures,
  addressWithZipCode,
  getCitiesByPrefectures,
} from '@/apis/candidate';
import { KANTO_ID, ZIP_CODE_REGEX, SPECIAL_ITEMS } from '@/constant';
import ModalBase from '@/components/common/ModalBase/index.vue';
import { Collapse, Tab } from 'bootstrap';
import { useMobile } from '@/hooks/useMobile';

const additionalStore = useAdditionalStore();
const prefectures = ref<PrefecturePrimary[]>([]);
const countries = ref<CountryPrimary[]>([]);
const cities = ref<CityPrimary[]>([]);
const valuesPrefecture = ref();
const valuesCities = ref();
const areaCity = ref<number | undefined>(KANTO_ID);
const modalCurrentPrefecture = ref<InstanceType<typeof ModalBase> | null>(null);
const errorMessageZipcode = ref('');

const { isMobile } = useMobile();

onMounted(() => {
  loadPrefectures();
  loadCountries();
});

const loadCountries = async (): Promise<void> => {
  const response = await getCountries();
  if (response.status === 200) countries.value = response.data;
};

const loadPrefectures = async (): Promise<void> => {
  const response = await getPrefectures();
  if (response.status === 200)
    prefectures.value = response.data.filter(
      (prefecture: PrefecturePrimary) => prefecture.id !== SPECIAL_ITEMS
    );
};

watch(
  () => [prefectures, additionalStore.prefecture_id],
  () => {
    if (!prefectures.value || !additionalStore.prefecture_id) return;

    const areaCityFound = prefectures.value.find((prefectureChildren) =>
      prefectureChildren.children?.some((item) => item.id === additionalStore.prefecture_id)
    );
    areaCity.value = areaCityFound?.id;
  }
);

watchEffect(async () => {
  if (additionalStore.prefecture_id) {
    const response = await getCitiesByPrefectures(additionalStore.prefecture_id);
    if (response.status === 200) {
      cities.value = response.data;
    }
  } else {
    cities.value = [];
  }
});

const searchAddressWithZipcode = async (): Promise<void> => {
  if (!additionalStore.zip_code) return;
  const response = await addressWithZipCode(additionalStore.zip_code);
  if (response.status == 200) {
    if (Object.keys(response.data).length === 0) {
      errorMessageZipcode.value = '見つかりませんでした';
    } else {
      const { id, prefecture_id, prefecture_name, city_name, parent_id, address } = response.data;
      errorMessageZipcode.value = '';
      additionalStore.prefecture_id = prefecture_id;
      additionalStore.city_id = id;
      additionalStore.prefecture_name = prefecture_name;
      additionalStore.city_name = city_name;
      additionalStore.address = address;
      valuesCities.value = { id, name: city_name };
      valuesPrefecture.value = { id: prefecture_id, name: prefecture_name };
      areaCity.value = parent_id;
      onExpandPrefecture();
    }
  }
};

const isZipCode = (e: any): void => {
  if (ZIP_CODE_REGEX.test(e.key)) {
    e.preventDefault();
  }
};

const addPefecture = (): void => {
  additionalStore.prefecture_id = valuesPrefecture.value.id;
  additionalStore.city_id = valuesCities.value.id;
  additionalStore.prefecture_name = valuesPrefecture.value.name;
  additionalStore.city_name = valuesCities.value.name;
};

const onOpenCurrentPrefecture = (): void => {
  modalCurrentPrefecture?.value?.onOpen();

  onCollapsePrefecture();
  onExpandPrefecture();
};

const onCollapsePrefecture = (): void => {
  if (!isMobile.value) {
    const prefectureCollapse = new Collapse(
      `#prefecture-item-${areaCity.value}-children-${additionalStore.prefecture_id}`
    );
    const prefectureCollapseExtraCity = new Collapse(
      `#prefecture-item-${areaCity.value}-children-${additionalStore.prefecture_id}-extra-cities`
    );

    prefectureCollapse.hide();
    prefectureCollapseExtraCity.hide();
  } else {
    const areaCityCollapse = new Collapse(`#prefecture-current-item-${areaCity.value}`);
    const prefectureCollapse = new Collapse(
      `#prefecture-current-item-${areaCity.value}-children-${additionalStore.prefecture_id}`
    );
    const cityCollapse = new Collapse(
      `#prefecture-item-${areaCity.value}-children-${additionalStore.prefecture_id}-extra-cities`
    );

    areaCityCollapse.hide();
    prefectureCollapse.hide();
    cityCollapse.hide();
  }
};

const onExpandPrefecture = (): void => {
  if (!isMobile.value) {
    const pillsPrefectureEl = document.getElementById(`pills-prefecture-${areaCity.value}-tab`);
    if (!pillsPrefectureEl) return;

    const pillsPrefectureTab = new Tab(pillsPrefectureEl);
    pillsPrefectureTab.show();

    const prefectureCollapse = new Collapse(
      `#prefecture-item-${areaCity.value}-children-${additionalStore.prefecture_id}`
    );
    const prefectureCollapseExtraCity = new Collapse(
      `#prefecture-item-${areaCity.value}-children-${additionalStore.prefecture_id}-extra-cities`
    );
    prefectureCollapse.show();
    prefectureCollapseExtraCity.show();
  } else {
    const collapseEls = document.getElementsByClassName('collapse-parent show');

    // Iterate over the elements and remove the 'show' class
    if (collapseEls.length) {
      for (let i = 0; i < collapseEls.length; i++) {
        const collapseEl = new Collapse(collapseEls[i]);
        collapseEl.hide();
      }
    }

    const areaCityCollapse = new Collapse(`#prefecture-current-item-${areaCity.value}`);
    const prefectureCollapse = new Collapse(
      `#prefecture-current-item-${areaCity.value}-children-${additionalStore.prefecture_id}`
    );
    const cityCollapse = new Collapse(
      `#prefecture-item-${areaCity.value}-children-${additionalStore.prefecture_id}-extra-cities`
    );

    areaCityCollapse.show();
    prefectureCollapse.show();
    cityCollapse.show();
  }
};

const updatePrefectureWithCity = (prefecture: unknown, city: unknown): void => {
  valuesPrefecture.value = prefecture;
  valuesCities.value = city;
};
</script>
